import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { MapScreenSettings } from "@/shared/v2/queries/interfacesV2";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useMapOrdersSettingsMutation = () => {
  const branch = useBranchId();

  const { t } = useTranslation();
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: () => {
      toast.error(t("errors.500"));
    },
    mutationFn: (body: MapScreenSettings) =>
      put2(`/internal/secure/pos/v1/couriers/map/screen/settings/${branch}`, {
        ...body,
        item_id: undefined,
      }),
  });
  return mutation;
};

export default useMapOrdersSettingsMutation;
